import { reactive } from 'vue';
import { logEntityView, type EntityViewLogRequest } from '@/api/modules/loggingApi';

// Global state to track the last logged ID for each resource type independently
const lastLoggedIds = reactive<Record<string, string | null>>({
    company: null,
    person: null,
    report: null,
    risk_profile: null
});

export function useActivityLogger() {
    const logView = async (data: EntityViewLogRequest) => {
        // If the ID hasn't changed for this specific type, don't log again
        if (lastLoggedIds[data.entity_type] === data.entity_id) {
            return;
        }
        // Validation: don't log if ID is missing or empty
        if (!data.entity_id || data.entity_id.trim() === '') {
            return;
        }
        try {
            await logEntityView(data);
            lastLoggedIds[data.entity_type] = data.entity_id;
        } catch (error) {
            // We don't want to break the UI if logging fails
            console.error(`[ActivityLogger] Failed to log ${data.entity_type} view:`, error);
        }
    };

    /**
     * Optional: Clear the memory for a specific type (e.g. on logout)
     */
    const resetLogger = (type?: keyof typeof lastLoggedIds) => {
        if (type) {
            lastLoggedIds[type] = null;
        } else {
            Object.keys(lastLoggedIds).forEach(k => {
                lastLoggedIds[k as keyof typeof lastLoggedIds] = null;
            });
        }
    };

    return {
        logView,
        resetLogger
    };
}
